import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import Store from 'redux/Store'
import setMessage from 'shared/redux/actions/setMessage'
import displayGenError from 'shared/utils/displayGenError'

interface bulkDeleteProps {
  selectedFilterValues: any
  setShowOverlay: Function
  setBulkActionsEnabled: Function
  setIsBulkDeleteLoading: Function
  setBulkDeleteCunter: Function
  handleBulkSelectionChanged: Function
}

const bulkDelete = async (props: bulkDeleteProps) => {
  props.setIsBulkDeleteLoading(true)
  props.setBulkActionsEnabled(false)
  let selectedUserIds: any = []

  props.selectedFilterValues.forEach((selectedUser) => selectedUserIds.push(selectedUser.id))

  const formData = {
    filterValueIds: selectedUserIds,
  }

  const response = await axiosPost(
    apiUrls.filterValues + '/' + apiUrls.actionBulkDelete,
    formData,
    (err: AxiosError) => {
      switch (err.response!.status) {
        case 500:
          Store.dispatch(
            setMessage(err.response!.data?.message ?? 'An error occurred', 'error', 'instant'),
          )
          break
        default:
          displayGenError({ setShowOverlay: () => {} })
      }
      return err.response
    },
  ).then((res) => {
    props.setIsBulkDeleteLoading(false)
    props.setBulkActionsEnabled(true)
    if (res!.status === 200) {
      const successText =
        selectedUserIds.length > 1 ? 'Filter Values have been deleted.' : 'Filter Value has been deleted.'
      props.handleBulkSelectionChanged([])
      Store.dispatch(setMessage(successText, 'success', 'instant'))
      props.setBulkDeleteCunter((prev) => prev + 1)
    }
  })
}

export default bulkDelete
